import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PanelPatientDataDisplay } from '../sharedPanelComponents/PanelPatientDataDisplay'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { CSpinner } from '@coreui/react-pro'
import {
  getPatientClinicalInfo,
  getPatientInsuranceInfo,
  getPatientMedInfo,
  getPatientRadiologyLabInfo,
} from '../../../../../components/common/shared/sharedPatientLogic'
import {
  PatientClinicalDisplay,
  PatientInsuranceDisplay,
  PatientLabRadiologyDisplay,
  PatientMedDisplay,
} from '../../../../../components/common/shared/sharedPatientCode'
import { getPatientData } from '../../../../../helper/backendHelper'
import PCCFacilityNoteDisplay from '../../../PatientDetails/PCCComponents/PCCFacilityNoteDisplay'
import { setPanelPCCHelper } from '../../../../../redux/sidePanel/sidePanelSlice'

export default function PanelPCCInfo() {
  const dispatch = useDispatch()
  const patientId = useSelector((state) => state.sidePanel.panelEncounter?.patient_id)
  const dos = useSelector((state) => state.sidePanel.panelEncounter?.service_date_from)

  const clinicalInfoData = useSelector(
    (state) => state.sidePanel.panelPatientPCCData?.clinicalInfoData,
  )
  const medInfoData = useSelector((state) => state.sidePanel.panelPatientPCCData?.medInfoData)
  const labsAndRadioInfoData = useSelector(
    (state) => state.sidePanel.panelPatientPCCData?.labsAndRadioInfoData,
  )
  const insuranceInfoData = useSelector(
    (state) => state.sidePanel.panelPatientPCCData?.insuranceInfoData,
  )

  const dataMissing = Object.keys(clinicalInfoData || {}).length === 0
  const [patientData, setPatientData] = useState({})
  const [isLoading, setIsLoading] = useState(dataMissing)

  useEffect(() => {
    if (patientId && dos) {
      Promise.allSettled([
        ...(dataMissing
          ? [
              getPatientClinicalInfo(patientId, (res) =>
                dispatch(setPanelPCCHelper({ field: 'clinicalInfoData', value: res })),
              ),
              getPatientMedInfo(patientId, (res) =>
                dispatch(setPanelPCCHelper({ field: 'medInfoData', value: res })),
              ),
              getPatientRadiologyLabInfo(patientId, null, (res) =>
                dispatch(setPanelPCCHelper({ field: 'labsAndRadioInfoData', value: res })),
              ),
              getPatientInsuranceInfo(patientId, (res) =>
                dispatch(setPanelPCCHelper({ field: 'insuranceInfoData', value: res })),
              ),
            ]
          : []),
        getPatientData(patientId).then((res) => {
          setPatientData(res?.data?.[0])
        }),
      ]).then(() => {
        setIsLoading(false)
      })
    }
  }, [patientId, dos, dataMissing])

  return (
    <div id={'PanelPCCInfo'}>
      {isLoading ? (
        <div className={'d-flex justify-content-center mt-2'}>
          <CSpinner />
        </div>
      ) : (
        <Tabs className={'row-tabs'} disableUpDownKeys>
          <TabList className={'row-tabs-list'}>
            <Tab>Clinical</Tab>
            <Tab>Meds</Tab>
            <Tab>Labs & Rad</Tab>
            <Tab>Facility Notes</Tab>
            <Tab>Insurance</Tab>
          </TabList>
          <hr />

          <TabPanel>
            <div className={'display-box'}>
              <PatientClinicalDisplay
                clinicalInfoData={clinicalInfoData}
                DisplayFunction={PanelPatientDataDisplay}
              />
            </div>
          </TabPanel>
          <TabPanel>
            <div className={'display-box'}>
              <PatientMedDisplay
                medInfoData={medInfoData}
                DisplayFunction={PanelPatientDataDisplay}
              />
            </div>
          </TabPanel>
          <TabPanel>
            <div className={'display-box'}>
              <PatientLabRadiologyDisplay
                labsAndRadioInfoData={labsAndRadioInfoData}
                patientId={patientId}
              />
            </div>
          </TabPanel>
          <TabPanel>
            <div className={'display-box'}>
              <PCCFacilityNoteDisplay
                patientDetails={{ ...patientData, patient_id: patientData._id }}
              />
            </div>
          </TabPanel>
          <TabPanel>
            <div className={'display-box'}>
              <PatientInsuranceDisplay
                insuranceInfoData={insuranceInfoData}
                DisplayFunction={PanelPatientDataDisplay}
              />
            </div>
          </TabPanel>
        </Tabs>
      )}
    </div>
  )
}
